import { Link, useLocation } from 'react-router-dom'
import { buildLoginHref } from '../auth/redirect'
import { SHELL_TOKENS, text } from '../shell/styles'

interface AuthRequiredStateProps {
  title: string
  body: string
  kicker?: string
  actionLabel?: string
  next?: string
}

export default function AuthRequiredState({
  title,
  body,
  kicker = 'Secure Session Required',
  actionLabel = 'Sign in',
  next,
}: AuthRequiredStateProps) {
  const location = useLocation()
  const loginHref = buildLoginHref(next ?? `${location.pathname}${location.search}`)

  return (
    <div
      style={{
        borderRadius: 20,
        border: `1px solid ${SHELL_TOKENS.brandLine}`,
        background: `
          radial-gradient(circle at top left, rgba(109,40,217,0.18), transparent 40%),
          linear-gradient(180deg, rgba(255,255,255,0.035), rgba(255,255,255,0.015))
        `,
        boxShadow: `0 24px 80px rgba(0,0,0,0.28), inset 0 1px 0 ${SHELL_TOKENS.border}`,
        padding: '28px 26px',
      }}
    >
      <div style={{ ...text.kicker, color: SHELL_TOKENS.brand, marginBottom: 10 }}>
        {kicker}
      </div>
      <div
        style={{
          fontSize: 22,
          fontWeight: 800,
          letterSpacing: '-0.01em',
          color: SHELL_TOKENS.ink,
          marginBottom: 10,
        }}
      >
        {title}
      </div>
      <div
        style={{
          fontSize: 13,
          lineHeight: 1.7,
          color: SHELL_TOKENS.inkDim,
          maxWidth: 640,
          marginBottom: 18,
        }}
      >
        {body}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <Link
          to={loginHref}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 42,
            padding: '0 18px',
            borderRadius: 12,
            textDecoration: 'none',
            background: SHELL_TOKENS.brand,
            color: SHELL_TOKENS.ink,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            fontFamily: 'var(--font-mono)',
            boxShadow: `0 12px 32px ${SHELL_TOKENS.brandGlow}`,
          }}
        >
          {actionLabel}
        </Link>
        <div
          style={{
            ...text.nano,
            color: SHELL_TOKENS.inkMuted,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
          }}
        >
          Saved work, uploads, and signed actions unlock after session hydration completes.
        </div>
      </div>
    </div>
  )
}
